import DraftProductService from '../../services/DraftProductService';
import draftProductUseCase from './draftProductUseCase';

const productFactory = draftProductUseCase({
  DraftProductService: DraftProductService(),
});

export default productFactory;
